import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function WhatYouGetSection() {
  const items = [{
    title: 'El Manual Completo',
    desc: "'Método 7-D Mornings' (Guía paso a paso)."
  }, {
    title: 'El Protocolo CES',
    desc: 'De 3 pasos para realizar bajo las cobijas.'
  }, {
    title: 'Guía de Salmos de Almohada',
    desc: 'Para interrumpir pensamientos intrusivos.'
  }, {
    title: 'Checklist de Inercia Cero',
    desc: 'Tu mapa visual de victoria diaria.'
  }, {
    title: 'Hoja de Trabajo',
    desc: "'Mi Altar de Mañana' para personalizar tu rutina de Gracia."
  }, {
    title: 'Bono Especial',
    desc: 'Guía de Emergencia para días de crisis profunda.',
    isBonus: true
  }];
  return <section className="py-12 md:py-14 px-6 bg-white" data-id="element-150">
      <div className="max-w-4xl mx-auto" data-id="element-151">
        <FadeIn data-id="element-152">
          <h2 className="font-serif text-2xl md:text-3xl text-navy mb-6 text-center" data-id="element-153">
            Lo que recibes hoy
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-3" data-id="element-154">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.08} data-id="element-155">
              <div className={`p-4 rounded-xl h-full border ${item.isBonus ? 'bg-gold/5 border-gold/20' : 'bg-cream border-divider/50'}`} data-id="element-156">
                <div className="flex items-start gap-3" data-id="element-157">
                  <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${item.isBonus ? 'bg-gold text-white' : 'bg-navy/5 text-navy'}`} data-id="element-158">
                    {item.isBonus ? <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-159">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" data-id="element-160" />
                      </svg> : <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-161">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-162" />
                      </svg>}
                  </div>
                  <div data-id="element-163">
                    <h3 className="font-serif text-lg text-navy mb-0.5" data-id="element-164">
                      {item.title}
                    </h3>
                    <p className="text-sm text-navy/70" data-id="element-165">{item.desc}</p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}